<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="550px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @closed="resetForm"
    >
      <div>
        <el-form ref="form" :model="form" label-width="100px" :rules="rules">
          <!-- 商品范围 （全部商品，指定商品） -->
          <el-form-item label="商品范围" prop="useLimit">
            <el-radio-group v-model="form.type">
              <el-radio label="0">全部商品</el-radio>
              <el-radio label="1">指定商品</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 选择店铺 搜索单选下拉框 -->
          <el-form-item label="选择店铺" prop="shopId" v-if="form.type === '1'">
            <el-select
              v-model="form.shopId"
              placeholder="请选择店铺"
              filterable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              :loading="loading"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.shopName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 选择商品 按钮选择 -->
          <el-form-item
            label="选择商品"
            prop="goodsIdList"
            v-if="form.type === '1'"
          >
            <el-button
              type="primary"
              @click="handleSelectGoods"
              size="small"
              :disabled="!form.shopId"
              >选择商品</el-button
            >
            <span>已选{{ form.goodsIdList.length }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handlePublish">确认</el-button>
      </div>
    </el-dialog>
    <!-- 店铺指定商品 -->
    <voucherShopGoodsDlg
      v-if="visible"
      ref="voucherShopGoodsDlgRef"
      @didSelectItem="didSelectItem"
    />
  </div>
</template>
<script>
import voucherShopGoodsDlg from "./voucherShopGoodsDlg.vue";
import { voucherGoodsSkuAdd } from "@/api/voucher";
import { queryShopListByKeyword } from "@/api/platActivityManage";
export default {
  name: "voucherAddDlg",
  components: {
    voucherShopGoodsDlg,
  },
  props: {
    title: {
      type: String,
      default: "新建",
    },
  },
  data() {
    return {
      visible: false,
      form: {
        type: "1",
        shopId: "",
        goodsIdList: [],
      },
      rules: {
        // 选择店铺
        shopId: [{ required: true, message: "请选择店铺", trigger: "blur" }],
        goodsIdList: [
          { required: true, message: "请选择商品", trigger: "blur" },
        ],
      },
      options: [],
      value: [],
      list: [],
      loading: false,
      states: [],
      pageType: "create",
      voucherId: "", //代金券 id
    };
  },
  mounted() {
    this.list = this.states.map((item) => {
      return { value: `value:${item}`, label: `label:${item}` };
    });
  },
  methods: {
    publicOpen(voucherId) {
      this.voucherId = voucherId;
      this.visible = true;
    },
    submit() {
      const { type } = this.form;
      let obj = {
        type,
        voucherId: this.voucherId,
      };
      if (type === "1") {
        obj.skuIds = this.form.goodsIdList;
      }
      voucherGoodsSkuAdd(obj).then((res) => {
        this.$message.success("添加成功");
        this.visible = false;
        this.$emit("fresh");
      });
    },
    handleValidate() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.form = {
        type: "1",
        shopId: "",
        goodsIdList: [],
      };
    },
    handleClose() {
      this.visible = false;
    },
    handleSave() {
      this.handleValidate();
    },
    handlePublish() {
      this.handleValidate();
    },
    remoteMethod(queryString) {
      let params = {};
      let restaurants = [];
      params.keyword = queryString;
      // 根据店铺名或手机号搜索店铺
      queryShopListByKeyword(params)
        .then((res) => {
          if (res) {
            restaurants = res;
            if (queryString !== "") {
              this.options = restaurants.filter((item) => {
                if (!item.shopName) return false;
                return (
                  item.shopName
                    .toLowerCase()
                    .indexOf(queryString.toLowerCase()) > -1
                );
              });
              this.loading = false;
            } else {
              this.options = [];
              this.loading = false;
            }
          }
        })
        .catch((err) => {});
    },
    handleSelectGoods() {
      this.$refs.voucherShopGoodsDlgRef.init({
        shopIds: [this.form.shopId],
        pageType: this.pageType,
      });
    },
    didSelectItem(e) {
      // this.selectedGoods = e;
      this.form.goodsIdList = e.map((item) => item.skuId);
    },
  },
};
</script>
<style scoped lang="scss"></style>
